import script from "./PaginationBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaginationBar.vue?vue&type=script&lang=ts&setup=true"

import "./PaginationBar.vue?vue&type=style&index=0&id=b00c0f2c&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b00c0f2c"]])

export default __exports__